import api from "../../APIIntercepter";

async function getCoursesAPI() {
  const res = await api.get("/course");
  return res.data;
}

async function getCourseByIdAPI(courseId) {
  const res = await api.get("/studentcourseassign/getMyPaidCourse/" + courseId);
  return res.data;
}

async function getMyAssignedCoursesAPI() {
  const res = await api.get("/studentcourseassign/getMyPaidCourses");
  return res.data;
}

async function getCourseFilesAPI(courseId) {
  const res = await api.get("/coursedetails?id=" + courseId);
  return res.data;
}

async function submitCourseBankSlipAPI(params) {
  const res = await api.post("/studentcourseassign", params);
  return res.data;
}

async function getMyCoursePaymentsByStatusAPI(status) {
  const res = await api.get(`/studentcourseassign/getMyPaidCoursesByStatus/${status}`);
  return res.data;
}

export {
  getCoursesAPI,
  getMyAssignedCoursesAPI,
  getCourseFilesAPI,
  getCourseByIdAPI,
  submitCourseBankSlipAPI,
  getMyCoursePaymentsByStatusAPI,
};
